<template>
  <div class="dx-top-border dx-card-vote">
    <div class="row">
      <div class="col-8">
        <p class="subtitle">{{ $t('rateThisItem') }}</p>
        <dx-button small primary :disabled="choosedTrue" @click.native="onVote(true)">{{ $t('liked') }}</dx-button>
        <dx-button small link :disabled="choosedFalse" @click.native="onVote(false)">{{ $t('didNotLike') }}</dx-button>
      </div>
      <div class="col-4 text-right">
        <dx-user-avatar
          :id="user.id"
          :name="user.nickname"
          :image="user.image"
          :items="user.card_count"
          />
      </div>
    </div>
  </div>
</template>

<script>
import DxUserAvatar from './DxUserAvatar.vue'
import DxButton from './DxButton.vue'

export default {
  name: 'dx-card-vote',
  props: {
    itemId: Number,
    user: Object
  },
  components: { DxUserAvatar, DxButton },
  data () {
    return {
      liked: null
    }
  },
  computed: {
    choosedTrue () {
      return this.liked === true
    },
    choosedFalse () {
      return this.liked === false
    }
  },
  methods: {
    onVote (liked) {
      this.liked = liked
      this.$emit('vote', liked)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/DxCardVote.vue